// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

const StyledHeading: React.ComponentType<{}> = tw.h2`
  font-bold
  mb-1
  text-2xl
`

/** A styled heading */
const Heading = ({
  children,
  className,
}: {
  children: React.Node,
  className?: string,
}): React.Node => (
  <StyledHeading className={className}>{children}</StyledHeading>
)

export default Heading
